import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCocosComponent } from './simple-icons-cocos.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCocosComponent ],
    exports:      [ SimpleIconsCocosComponent ],
    bootstrap:    []
})
export class SimpleIconsCocosModule {}
